import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { PrimaryHeading } from '@components/atoms/PrimaryHeading'
import { IInvestmentBase } from '@/types'
import { PortfolioCard } from '@components/molecules/PortfolioCard'
import { getCompanyLogo } from '@/utils'
import styles from './index.module.scss'

type Props = {
  investments: IInvestmentBase[]
}

export const ProfilePortfolio: FC<Props> = ({ investments }) => {
  const { t } = useTranslation(['companies-users-[id]'])
  return (
    <div>
      <div className={styles.heading}>
        <PrimaryHeading backgroundText='PORTFOLIO' htmlTagType='h2'>
          {t('投資ポートフォリオ')}
        </PrimaryHeading>
      </div>
      <div className={styles.content}>
        {investments.map((inv) => {
          return (
            <PortfolioCard
              key={inv.id}
              avatar={getCompanyLogo(inv.company)}
              name={inv.company.name}
              href={inv.company.status === 'published' ? `/companies/${inv.company.slug}` : ''}
            />
          )
        })}
      </div>
    </div>
  )
}
